const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

export const parseYouTubeVideoId = (value) => {
  const raw = String(value || '').trim();
  if (!raw || raw.length > 2048) return '';
  try {
    const url = new URL(raw.includes('://') ? raw : `https://${raw}`);
    if (url.protocol !== 'https:') return '';
    const host = url.hostname.toLowerCase();
    let videoId = '';
    if (host === 'youtu.be') {
      videoId = url.pathname.split('/').filter(Boolean)[0] || '';
    } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
      const parts = url.pathname.split('/').filter(Boolean);
      if (url.pathname.replace(/\/$/, '') === '/watch') videoId = url.searchParams.get('v') || '';
      else if (parts.length >= 2 && ['shorts', 'embed', 'live'].includes(parts[0])) videoId = parts[1];
    }
    return VIDEO_ID_PATTERN.test(videoId) ? videoId : '';
  } catch (error) {
    return '';
  }
};

export const scoreSummary = (events) => {
  const plus = events.filter((event) => event.delta === 1).length;
  const minus = events.length - plus;
  return { plus, minus, total: plus - minus };
};

export const communityAverage = (scores = []) => {
  const totals = scores
    .filter((score) => score.status === 'visible' && typeof score.total === 'number' && Number.isFinite(score.total))
    .map((score) => score.total);
  return {
    average: totals.length ? totals.reduce((sum, total) => sum + total, 0) / totals.length : null,
    count: totals.length,
  };
};

export const buildScoreCurve = (events, durationSeconds) => {
  const points = [{ time: 0, score: 0 }];
  let score = 0;
  [...events].sort((a, b) => a.time - b.time).forEach((event) => {
    score += event.delta;
    points.push({ time: event.time, score });
  });
  const lastTime = points[points.length - 1].time;
  points.push({ time: Math.max(Number(durationSeconds) || 0, lastTime, 1), score });
  return points;
};
